module.exports = __webpack_public_path__ + "static/media/banesco.a3674744.png";